<template>
  <div class="single-banner flex">
    <div v-if="needRemove"><i class="el-icon-remove-outline" @click="remove" /></div>
    <template v-if="showUploadImage">
      <div>
        <div class="flex">
          <div class="label">序号<span class="index-num">{{ index + 1 }}</span></div>
          <UploadImage :show-replace="false" :limit-size="limitSize" :url="selfConfig.imageUrl" :save-path="savePath" size-tips="750*540" @upload="uploader" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label mgr10">链接地址</div>
          <el-input v-model="selfConfig.linkUrl" placeholder="请填写banner跳转地址链接" style="width:360px;background: transparent;" />
          <el-button type="primary" style="margin-left:20px;" @click="handleReset">重置</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <div class="flex" style="margin-left:58px;">
          <div class="label">序号<span class="index-num">{{ index + 1 }}</span></div>
          <img style="width: 107px;height: auto;margin-right: 60px" :src="selfConfig.imageUrl" alt="">
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label mgr10">标题：</div>
          <span>{{ selfConfig.linkUrl }}</span>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import UploadImage from '@/components/UploadImage';

export default {

  name: 'BannerConfig',
  components: { UploadImage },
  props: {
    savePath: {
      type: String,
      default: '',
    },
    limitSize: {
      type: Number,
      default: 2,
    },
    showUploadImage: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => {
        return {
          imageUrl: '',
          linkUrl: '',
        };
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    needRemove: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selfConfig: {
        imageUrl: '',
        linkUrl: '',
      },
    };
  },
  watch: {
    config: {
      handler(newV, old) {
        this.selfConfig = newV;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleReset() {
      this.selfConfig = {
        imageUrl: '',
        linkUrl: '',
        title: '',
      };
      this.$emit('updateConfig', this.selfConfig, this.index);
    },
    uploader(file) {
      this.selfConfig.imageUrl = file;
      this.$emit('updateConfig', this.config, this.index);
    },
    remove(index) {
      this.$emit('remove');
    },
  },
};
</script>

<style scoped lang="less">
.single-banner {
  background: #f7f7f7;
  padding: 30px 50px;
  min-width: 1100px;
  // height: 280px;
  align-items: center;
  margin-top: 20px;

  .el-icon-remove-outline {
    font-size: 30px;
    color: #bbbbbb;
    line-height: 32px;
  }

  .flex {
    height: 150px;
    align-items: center;
  }
  .label {
    margin-right: 71px;
    &.mgr10 {
      margin-right: 10px;
    }
    .index-num {
      margin-left: 15px;
    }
  }
}
/deep/.uploader {
  margin-right: 60px;
  .uploader-image {
    width: 210px;
    height: 150px;
    .el-upload {
      width: 210px;
      height: 150px;
    }
    .el-icon-plus {
      width: 210px;
      height: 150px;
    }
  }
  .uploader-info {
    display: inline-block;
    margin-top: 5px;
    &:last-child {
      margin-left: 10px;
    }
  }
}
.add-btns {
  display: inline-block;
  border: 1px dashed #bbbbbb;
  color: #bbbbbb;
  padding: 0px 20px;
  margin-top: 20px;
  border-radius: 6px;
  cursor: pointer;
}
</style>
<style lang="less">
.single-banner {
  .el-input__inner {
    background: transparent;
  }
}
</style>
